import React from "react";

export default function NoMatch() {
  return <p>This is not the page you are looking for</p>;
}
